








































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ChangeStatusModal from '@/app/components/MachineRent/ChangeStatusModal.vue'
/* api */
import MachineRentDetailApi from '@/app/model/api/machineRentDetailApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import Session from '@/app/module/session'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorInfo,
    ErrorModal,
    Error409Modal,
    Loading,
    ChangeStatusModal
  }
})
export default class MachineRentDetails extends Vue {
  private alertText: string = ''
  private alertTitle: string = ''
  private constantValue: any = []
  private machineType: number|null = null
  private machineRentData: any = {
    field_name: '',
    group_name: '',
    machine_name: '',
    machine_type: null,
    created_at: '',
    created_name: '',
    rent_start_date: '',
    rent_end_date: '',
    use_start_date: '',
    use_end_date: '',
    use_days: null,
    remarks: '',
    role: {
      role_reception_name: null,
      role_send_name: null,
      role_machine_operator_name: null,
      role_return_name: null,
      role_maintenance_name: null,
      role_house_manage_name: null
    },
    send: {
      send_name: '',
      send_zip_code: '',
      send_prefecture: '',
      send_address1: '',
      send_address2: '',
      send_tell: '',
      send_mailaddress: ''
    },
    billing: {
      billing_name: '',
      billing_zip_code: '',
      billing_prefecture: '',
      billing_address1: '',
      billing_address2: '',
      billing_tell: '',
      billing_mailaddress: ''
    }
  }
  private machineRentStepHistoryData: any = {}
  private machineRentStepData: any = {}
  private nextSteps: any = ['承認', '配送', '配送受取', '機械返却', '返却受取', '貸出完了']
  /* 表示非表示 */
  private show400ErrorMessage: boolean = false
  private showLoading: boolean = true
  private showError409Modal: boolean = false

  created () {
    // セレクトボックス情報取得
    this.constantValue = JSON.parse(Local.getConstantValue()!)
    this.getMachineRentList()
  }

  /* 次の行動ステップの判定 */
  private judgmentNextStep () {
    for (let i in this.nextSteps) {
      if (parseInt(i) === (this.machineRentData.step - 1)) {
        return this.nextSteps[i]
      }
    }
  }

  /* 機械タイプの判定 */
  private judgmentMachineType (type: number) {
    for (let i in this.constantValue.machine_types) {
      if (this.constantValue.machine_types[i].machine_type_id === type) {
        return this.constantValue.machine_types[i].machine_type_name
      }
    }
  }

  private judgmentStepName (step: number) {
    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].step_name
      }
    }
  }

  private judgmentStatusName (step: number) {
    for (let i in this.constantValue.machine_steps) {
      if (this.constantValue.machine_steps[i].step === step) {
        return this.constantValue.machine_steps[i].status_name
      }
    }
  }

  private judgmentNextStatusName (isCancel: boolean) {
    if (isCancel) {
      if (this.machineRentData.step === 1) {
        return '依頼却下/キャンセル'
      } else {
        return '中止'
      }
    } else {
      return this.judgmentStatusName(this.machineRentData.step + 1)
    }
  }

  private dateToStringYmd (date: any, unit: string) {
    if (date !== null && date !== '') {
      return DateClass.dateToStringYmd(new Date(date), unit)
    } else {
      return ''
    }
  }

  private dateToStringMd (date: any, unit: string) {
    if (date !== null && date !== '') {
      return DateClass.dateToStringMd(new Date(date), unit)
    } else {
      return ''
    }
  }

  private getMachineRentList () {
    (async () => {
      const result = await MachineRentDetailApi.getMachineRentDetail(this.$route.params.machine_rent_id)
      if (result.isOk()) {
        this.machineRentData = result.getPayload().machine_rent
        this.machineRentStepHistoryData = result.getPayload().machine_rent_step_histories
        this.machineRentStepData = result.getPayload().machine_rent_steps
        this.currentStatusPosition()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }
  private leftPosition: number = 0
  private currentStatusPosition () {
    let position = 165
    if (this.machineRentData.step === 1) {
      this.leftPosition = 0
    } else {
      this.leftPosition = position * (this.machineRentData.step - 1)
    }
  }

  private showChangeStatusModal: boolean = false
  private changeData: any = {}
  private changeStatus (isCancel: boolean) {
    this.changeData = {
      step: this.machineRentData.step + 1,
      step_name: this.judgmentStepName(this.machineRentData.step + 1),
      now_status_name: this.judgmentStatusName(this.machineRentData.step),
      next_status_name: this.judgmentNextStatusName(isCancel),
      is_canceled: isCancel,
      time_stamp: this.machineRentData.time_stamp
    }
    this.showChangeStatusModal = true
  }

  private doSaveStatus (data: any) {
    this.showChangeStatusModal = false
    // 最新の詳細を取得
    this.getMachineRentList()
    this.changeData = {}
  }

  private doEdit () {
    this.$router.push('/machine-rent/' + this.$route.params.machine_rent_id + '/edit').catch(e => {})
  }

  private doCancel () {
    this.$router.push('/machine-rent').catch(e => {})
  }
}
